import httpCacheInst from '../utilis/httpCacheService';

const cacheService = {
	createHttpObject: () => {
		return httpCacheInst();
	},
	getQueuePendingRefresh: async () => {

		var httpObj = cacheService.createHttpObject();
	
		const res = await httpObj({
			method: 'get',
			url: `/CheckQueuePendingRefresh`
		});
	
		return res.data;
	},
	getOldProjects: async () => {

		var httpObj = cacheService.createHttpObject();
	
		const res = await httpObj({
			method: 'get',
			url: `/OldProjects`
		});
	
		return res.data;
	},
	refreshProject: async (projectId, types) => {
		var httpObj = cacheService.createHttpObject();
	
		const res = await httpObj({
			method: 'post',
			url: `/RefreshProjectCache`,
			data: {
				ProjectId: projectId,
				TypesToRefresh: types || []
			}
		});
	
		return res.data;
	}
}

export default cacheService;